var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-textarea',{attrs:{"cols":_vm.cols,"placeholder":_vm.$t('components.jsonField.placeholder'),"rows":_vm.rows},on:{"blur":_vm.onBlur},model:{value:(_vm.stringValue),callback:function ($$v) {_vm.stringValue=$$v},expression:"stringValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }